<template>
<div
  class="assignment-detail"
  v-loading="!show"
  element-loading-text="拼命加载中"
  element-loading-spinner="el-icon-loading">
  <el-card class="head-tit" shadow="hover">
    任务详情
  </el-card>
  <editTaskInfo :taskEdit="taskEdit"></editTaskInfo>
  <!-- 商品列表信息 -->
  <el-card shadow="hover" class="assignmentedit-List" v-if="show">
    <div class="top">
      <label class="top-tit">商品信息</label>
      <el-button type="text" class="handle-btn" @click="getTaskLog">操作记录</el-button>
    </div>
    <el-table
      style="margin: 20px 0"
      :data="goodsListEdit"
      border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="name"
        label="商品名称"
        min-width="140"
        align="center">
      </el-table-column>
      <el-table-column
        prop="typeName"
        align="center"
        min-width="120"
        label="商品属性">
      </el-table-column>
      <el-table-column
        prop="standard"
        align="center"
        min-width="120"
        label="规格">
      </el-table-column>
      <el-table-column
        prop="box"
        align="center"
        width="130"
        label="箱规(件/箱)">
      </el-table-column>
      <el-table-column
        align="center"
        width="180"
        :label="'计划数量 \n (正常品)'">
        <template slot-scope="scope">
          <div>{{scope.row.num ? scope.row.num : '0'}}{{ scope.row.minUnitName }}</div>
          <div style="color: #808080">
            <label>({{scope.row.num ? parseInt(scope.row.num / scope.row.box): '0'}}{{ scope.row.maxUnitName }}</label>
            <label>{{scope.row.num ? scope.row.num % scope.row.box: '0'}}{{ scope.row.minUnitName }})</label>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        min-width="180"
        v-if=" taskEdit.taskType === 'TASK_TYPE_EMPTY' ||  taskEdit.taskType === 'TASK_TYPE_OTHER_OUT'"
        :label="'计划数量 \n (破损品)'">
        <template slot-scope="scope">
          <div>{{scope.row.wornNum ? scope.row.wornNum : '0'}}{{ scope.row.minUnitName }}</div>
          <div style="color: #808080">
            <label>({{scope.row.wornNum ? parseInt(scope.row.wornNum / scope.row.box): '0'}}{{ scope.row.maxUnitName }}</label>
            <label>{{scope.row.wornNum ? scope.row.wornNum % scope.row.box: '0'}}{{ scope.row.minUnitName }})</label>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="taskEdit.status == 3"
        align="center"
        :label="'完成数量 \n (正常品)'"
        min-width="180">
        <template slot-scope="scope">
          <div :style="{color:parseInt(scope.row.actualNum) >0 ? 'red':''}">
            <label>{{scope.row.actualNum ? scope.row.actualNum : 0}}{{ scope.row.minUnitName }}</label>
          </div>
          <div style="color: #808080">
            <label>({{scope.row.actualNum ? parseInt(scope.row.actualNum / scope.row.box): '0'}}{{ scope.row.maxUnitName }}</label>
            <label>{{scope.row.actualNum ? scope.row.actualNum % scope.row.box: '0'}}{{ scope.row.minUnitName }})</label>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="taskEdit.status == 3 "
        align="center"
        :label="'完成数量 \n (破损品)'"
        min-width="180">
        <template slot-scope="scope">
          <div :style="{color:parseInt(scope.row.actualWornNum) >0 ? 'red':''}">
            <label>{{scope.row.actualWornNum ? scope.row.actualWornNum : 0}}{{ scope.row.minUnitName }}</label>
          </div>
          <div style="color: #808080">
            <label>({{scope.row.actualWornNum ? parseInt(scope.row.actualWornNum / scope.row.box): '0'}}{{ scope.row.maxUnitName }}</label>
            <label>{{scope.row.actualWornNum ? scope.row.actualWornNum % scope.row.box: '0'}}{{ scope.row.minUnitName }})</label>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="barCode"
        label="商品条码"
        align="center"
        min-width="200">
        <template slot-scope="scope">
          <label v-if="scope.row.barCode">{{scope.row.barCode}}</label>
          <label v-else>-</label>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsCode"
        label="商品编码"
        align="center"
        min-width="200">
        <template slot-scope="scope">
          <label v-if="scope.row.goodsCode">{{scope.row.goodsCode}}</label>
          <label v-else>-</label>
        </template>
      </el-table-column>
      <el-table-column
        prop="supplier"
        align="center"
        label="供应商"
        min-width="200">
        <template slot-scope="scope">
          <label v-if="scope.row.supplier">{{scope.row.supplier}}</label>
          <label v-else>-</label>
        </template>
      </el-table-column>
    </el-table>
    <div class="btm-label">
      <label style="margin-left: auto;color: #808080">计划总数：SKU种数{{taskEdit.skuNum}}，共{{taskEdit.num}}件</label>
      <label v-if="this.taskEdit.status === 3" style="margin-left: auto;color: #808080;padding:5px 0">完成总数：SKU种数{{goodsListEdit.length}}，共{{taskEdit.actualNum ? taskEdit.actualNum : 0}}件</label>
    </div>
  </el-card>
  <!-- 单据上传 -->
  <el-card v-if="taskEdit.status == 3 && show" shadow="hover" class="assignmentedit-List">
    <label class="top-tit">单据上传</label>
    <supplementList :taskEdit="taskEdit"></supplementList>
    <!-- <upload-pic ref="upload" :pictureList="urlList" :isDisabled="true" :limit="3"></upload-pic> -->
  </el-card>
  <task-log :taskLogVisible.sync='taskLogVisible' :taskLogList='taskLogList' @closeDialog="closeDialog"></task-log>
</div>
</template>

<script>
import assignmentManage from '@/store/assignmentManage/index'
import {GETTASKDETAILS, GETTASKLOGLIST} from '@/store/assignmentManage/types'
import UploadPic from '../components/uploadImage'
import editTaskInfo from '../components/editTaskInfo'
import supplementList from '../components/supplementList'
import taskLog from '../components/taskLog'
import user from '@/store/user/index'

export default {
  name: 'assignmentEdit',
  props: [],
  data () {
    return {
      show: false,
      taskLogVisible: false,
      code: '', // 商品code
      saas: ''
    }
  },
  components: {
    UploadPic, editTaskInfo, supplementList, taskLog
  },
  computed: {
    // 任务详情数据
    taskEdit () {
      return assignmentManage.state.taskEdit
    },
    // 列表数据
    goodsListEdit () {
      return assignmentManage.state.goodsListEdit
    },
    urlList () {
      let aa = []
      if (this.taskEdit.urls) {
        aa = this.taskEdit.urls.map(item => {
          return {
            url: item
          }
        })
      }
      return aa
    },
    // 标识
    assigneditMark () {
      return assignmentManage.state.assigneditMark
    },
    // 签收信息
    taskSignRegisterList () {
      return assignmentManage.state.signForList
    },
    // 操作记录
    taskLogList () {
      return assignmentManage.state.taskLogList
    },
    userinfo () {
      return user.state.userinfo
    }
  },
  watch: {
    // 重新请求数据
    $route (to, from) {
      if (this.$route.params.code) {
        this.code = this.$route.params.code
        this.getList()
        this.show = false
        setTimeout(() => {
          this.show = true
        }, 500)
      }
    },
    assigneditMark: {
      deep: true,
      handler (val) {
        if (val === 1) {
          assignmentManage.state.assigneditMark = 0
          this.getList()
        }
      }
    }
  },
  created () {
    if (this.$route.params.nature === '2') this.$route.meta.title = '入库-详情'
  },
  mounted () {
    this.code = this.$route.params.code
    // 获取编辑回显数据
    this.getList()
    if (this.userinfo.identity === 3) {
      this.saas = '1'
    }
    setTimeout(() => {
      this.show = true
    }, 500)
  },
  methods: {
    // 获取编辑回显数据
    getList () {
      let params = {
        code: this.code
      }
      this.$store.dispatch(GETTASKDETAILS, params)
    },
    // 查看操作记录
    getTaskLog () {
      let params = {
        code: this.code
      }
      this.$store.dispatch(GETTASKLOGLIST, params)
      this.taskLogVisible = true
    },
    // 关闭操作记录窗口
    closeDialog (val) {
      this.taskLogVisible = val
    }
  }
}
</script>
<style>
.el-tooltip__popper.is-dark {
  opacity: .8;
}

</style>
<style scoped>
.top{
  position: relative;
}
.handle-btn{
  max-width: 200px;
  position: absolute;
  right: 0;
  top:0;
  z-index: 1000;
}
  .item {
    width: 200px;
  }
  .head-tit {
    font-size: 20px;
    font-weight: bold;
  }
  .top-tit{
    font-size: 20px;
    padding-bottom: 20px;
    display: flex;
    font-weight: bold;
    align-items: center;
    color: #696969;
  }
  .top-code {
    font-size: 18px;
    line-height: 31px;
    height: 30px;
    overflow: hidden;
  }
  .assignment-content {
    flex-direction: column;
    display: flex;
  }
  .assignment-content label {
    padding: 5px 0;
  }
  .btm-button {
    width: 58%;
    margin-left: auto;
    padding-top: 20px;
  }
  .operation-warp {
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #409EFF;
    cursor: pointer;
  }
  .operation-warp div:hover {
    color: #66b1ff;
  }
  .btm-label {
    display: flex;
    flex-direction: column;
  }

  .assignmentedit-List {
    padding-left: 20px;
  }
  .assignmentedit-List >>> .el-table .cell{
    white-space:pre-line;
  }

  .assignment-detail .top-wrap_con {
    position: relative;
  }

</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/warehouse/WarehouseIntoDetail.vue